export const VOTER_INDEX_ROUTE = "/voter";
export const VOTER_VIEW_CONTEST_CATEGORY_CONTESTANTS =
  "/voter/contests/:id/contestants";

export const VOTER_PROFILE_INDEX_ROUTE = "/voter/profile";
export const VOTER_VOTE_CONTESTANRT_ROUTE = "/voter/phases/:id/vote-contestant";
export const VOTER_CONTEST_PHASES_ROUTE = "/voter/contests/:id/phases";
